<div class="col-12 mainContent">
    <div class="col-3 left">
        <div id="scrollfix">
            <label>買主搜尋</label>
            <!-- <buyer-select (ChangeEvt)="BuyerTemp($event)" 
             [Countries]="buyerCountries" [Industries]="buyerindustries">
            </buyer-select> -->
            <buyer-select *ngIf="OptionReady" [Countries]="Countries" [Industries]="Industries" (ChangeEvt)="BuyerTemp($event)"></buyer-select>

            <div class="btn" (click)="AddToTag()">加入搜尋條件</div>

            <div class="checkbox">
                <label for="c1">隱藏「取消來台」買主</label>
                <label class="switch">
                    <input type="checkbox" (change)="BuyerEvt($event)"/>
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
    </div>
    <div class="col-9 right">
        
        <!-- <div class="search">
            <h1>儲存買主清單</h1>

            <div style="margin-bottom:2rem;"></div>

            <div class="content animated fadeIn">

                <div class="card">
                    <div class="info top">
                        <div class="status valid">可報名</div>
                        <label>EXATI TECNOLOGIA E DESENVOLVIMENTO DE SISTEMAS LTDA</label>
                        <p>
                            <span class="date">2020/12/22</span>
                            <span class="area">巴西(南美)</span>
                            <span class="tag">資通訊電子零組件／綠能產品</span>
                        </p>
                    </div>
                    <div class="divider"></div>
                    <div class="tags">
                        <span>LED Driver (Power Supply)</span>
                        <span>Electronic Components</span>
                        <span>PCB(OEM)</span>
                        <span>PCB(OEM)</span>
                    </div>
                </div>

                <div class="card">
                    <div class="info">
                        <div class="status full">已額滿</div>
                        <label>EXATI TECNOLOGIA E DESENVOLVIMENTO DE SISTEMAS LTDA</label>
                        <p>
                            <span class="date">2020/12/22</span>
                            <span class="area">巴西(南美)</span>
                            <span class="tag">資通訊電子零組件／綠能產品</span>
                        </p>
                    </div>
                    <div class="divider"></div>
                    <div class="tags">
                        <span>LED Driver (Power Supply)</span>
                        <span>Electronic Components</span>
                        <span>PCB(OEM)</span>
                        <span>PCB(OEM)</span>
                        <span>PCB(OEM)</span>
                    </div>
                </div>
                
                <ng-container *ngFor="let item of BuyerData">
                    <buyerCard [Data]="item"></buyerCard>
                </ng-container>

                <pagination *ngIf="BuyerPager" [Pager]="BuyerPager" (PageSetEvt)="SetBuyerPage($event)"></pagination>

            </div>
        </div> -->

        <div class="search">

            <h1>儲存買主清單 </h1>
            <div class="term" style="margin-bottom: 1.5rem;">
                <ng-container *ngFor="let item of TagGroup;let _g = index;">
                    <div *ngIf="item.tag.length > 0" class="tag {{ (_g == 0) ? 'first' : '' }}" >
                        <label>{{item.name}}</label>
                        <p>
                            <ng-container *ngFor="let _child of item.tag;">
                                <label>{{_child.name}}<i class="icon icon-close" (click)="RemoveTag(_child.tag_index)">&#xe802;</i></label>
                            </ng-container>
                        </p>
                    </div>
                </ng-container>
            </div>
            <div style="margin-bottom:2rem;"></div>
            <div class="content animated fadeIn">
                <empty *ngIf="!Data || Data.length == 0"></empty>
                <ng-container *ngFor="let item of Data">
                    <buyerCard [Data]="item"></buyerCard>
                </ng-container>
                <pagination *ngIf="Pager" [Pager]="Pager" (PageSetEvt)="SetPage($event)"></pagination>
            </div>
        </div>
    </div>
</div>